import React from 'react';
import CantDeleteTooltip from '../components/CantDeleteTooltip';

const TestComponent = () => (
    <CantDeleteTooltip />
)
    
export default TestComponent;